/** The full-page History of one record (any subject type: IME now, SUPP / INVOICE later). */
export const ACTIVITY_HISTORY_ROUTE = '/view/activity-history/:subjectType/:id'

/** The tab title of a History page opened without the record's name. */
export const ACTIVITY_HISTORY_DEFAULT_TITLE = 'History'

/**
 * The dashboard tab config of a record's History page. One tab per record: opening it again
 * focuses the tab already open.
 */
export const activityHistoryPage = (
  subjectType: string,
  id: string,
  title?: string
) => ({
  path: `/view/activity-history/${encodeURIComponent(subjectType)}/${id}`,
  tabTitle: title || ACTIVITY_HISTORY_DEFAULT_TITLE,
  postFix: ' - History',
  tabName: `History-${subjectType}-${id}`,
})

const HISTORY_PATH =
  /^\/view\/activity-history\/([^/?#]+)\/([^/?#]+)\/?(?:[?#].*)?$/

/**
 * The record a History page link is about ("/view/activity-history/IME/{id}"), or null when the
 * link is not one: a link K-Assist hands off to opens the History page's own tab.
 */
export const activityHistoryFromPath = (
  path: string | null | undefined
): { subjectType: string; id: string } | null => {
  const match = HISTORY_PATH.exec(path ?? '')
  if (!match) {
    return null
  }
  try {
    return { subjectType: decodeURIComponent(match[1]), id: match[2] }
  } catch {
    return null
  }
}
